import React from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  IconButton,
  Input,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { editField, addField, deleteArrayItem } from "../redux";

import RemoteCommands from "./RemoteCommands";
import RemoteTargeting from "./RemoteTargeting";

export const DEFAULT_FEATURES = [
  {
    "feature name": {
      enabled: true,
      url: "http://www.beta.com",
      interval: 20,
    },
  },
];

export const DEFAULT_TARGETING = {
  models: [],
  swid: [],
  times: [],
  state: [],
  environment: [],
  timezone: [],
  internet: [],
  rxid: [],
  dma: [],
  zip: [],
  bandwidth: "",
};

const Remote = () => {
  const { root: rows } = useSelector(({ file }) => file);
  const dispatch = useDispatch();
  const addRemote = () =>
    dispatch(
      addField(`root`, {
        title: "New Feature",
        features: DEFAULT_FEATURES,
        targeting: DEFAULT_TARGETING,
      })
    );

  const remove = (i) => {
    const toDelete = window.confirm(
      "Are you sure you want to delete this feature group?"
    );
    toDelete && dispatch(deleteArrayItem(`root`, i));
  };

  return (
    <>
      <div style={{ marginTop: "1rem" }}>
        <Button
          onClick={addRemote}
          variant="contained"
          size="small"
          color="primary"
        >
          New Feature Group
        </Button>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width={"50%"}>Name</TableCell>
            <TableCell>Features</TableCell>
            <TableCell>Targeting</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => {
            return (
              <TableRow key={i}>
                <TableCell>
                  <Input
                    fullWidth
                    value={row.title}
                    onChange={(e) =>
                      dispatch(
                        editField(`root[${i}].title`, e.currentTarget.value)
                      )
                    }
                  />
                </TableCell>
                <TableCell>
                  <RemoteCommands i={i} />
                </TableCell>
                <TableCell>
                  <RemoteTargeting i={i} />
                </TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => remove(i)}>
                    <DeleteIcon fontSize="inherit" />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};

export default Remote;
